module.exports = __webpack_public_path__ + "static/media/sell-used-cars-ipswich.309edd6f.png";